module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"popup":{"title":"Manage subscription"},"form":{"selecNewComplianceStatus":"Select new compliance status","subscriptionStartDate":"Subscription start date","subscriptionEndDate":"Subscription end date","trialStartDate":"Trial start date","trialEndDate":"Trial end date","selectCompliancePackage":"Select compliance package"}}}')
  delete Component.options._Ctor
}
